module.exports = __webpack_public_path__ + "img/codecn.44534dcc.png";